export default "__VITE_ASSET__B74V2A_2__"